import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NavigationError, provideRouter, Router, withHashLocation } from '@angular/router';
import { filter } from 'rxjs';

import { lucideIconsProvider } from './core/config/lucide-icons.provider';
import { ChunkLoadErrorHandler } from './core/errors/chunk-load-error.handler';
import { reloadOnceForChunkError } from './core/errors/chunk-load';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { OperatorThemeService } from './core/theme/operator-theme.service';
import { TenantService } from './core/tenant/tenant.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(async () => {
      const tenantService = inject(TenantService);
      const themeService = inject(OperatorThemeService);
      const router = inject(Router);
      router.events
        .pipe(filter((event): event is NavigationError => event instanceof NavigationError))
        .subscribe((event) => {
          reloadOnceForChunkError(event.error);
        });

      await tenantService.resolve();

      if (!tenantService.notFound()) {
        await themeService.loadForTenant();
      }
    }),
    lucideIconsProvider,
  ],
};
